import * as React from 'react'
import { Link } from 'react-navi'

import './activity_nav.scss'

import { IProps } from './interface'

class ActivityNav extends React.Component<IProps> {
    public render = () => {
        const { activityNavlist, currentKey } = this.props.data
        return (
            <ul className="activity-nav">
                {activityNavlist.length > 1 && activityNavlist.map(item => {
                    return <Link className="item-container" href={item.href} key={item.key}>
                        <li className={`item${item.key === currentKey ? ' selected' : ''}`}>{item.name}</li>
                    </Link>
                })}
            </ul>
        )
    }
}

export {
    ActivityNav
}


// WEBPACK FOOTER //
// ./src/components/common/activity_nav/activity_nav.tsx